export default "/assets/images/filter-exploded.243051dbc3c2f384.webp";